import { gql } from '@apollo/client';

const ADD_COMMENT = gql`mutation addComment(
  $versionId:Int!
  $pageNo:Int!
  $comment:String
  $figureIds: [Int!]
) {
	resourceComments{
		addComment(
      resourceVersionId: $versionId
      pageNo: $pageNo
      comment: $comment
      figureIds: $figureIds
    ){
			author
			avatarUrl
			comment
			page
			pageNo
			resourceVersionCommentId
			resourceVersionId
			statusId
			timestamp
			userId
			versionCommentNumber
      connectedFigureIds
		}
	}
}`;

export default ADD_COMMENT;
